<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        return-object
        v-model="item"
        label="Období"
        :hide-details="hideDetails"
        :outline="outline"
        class="mx-2"
        :rules="rules"
        :disabled="disabled"
      >
        <template slot="item" slot-scope="props">
          <span v-html="padMesic(props.item.mesic)"></span><span>/{{props.item.rok}}</span>
        </template>
        <template slot="selection" slot-scope="props">
          <span v-html="padMesic(props.item.mesic)"></span><span>/{{props.item.rok}}</span>
        </template>
      </v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      item: null
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Number,
    all: Boolean,
    disabled: Boolean
  },
  watch: {
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v.id);
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.api.get("ciselniky/obdobi").then(function(_body) {
        this.items = _body;
        if (this.value != null) {
          var $f = this.items.filter((x) => x.id == this.value);
          if ($f.length > 0)
            this.item = $f[0];
          else
            this.item = _body.length > 0 ? _body[0] : null;
        }
        else {
          this.item = _body.length > 0 ? _body[0] : null;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    padMesic ($v) {
      $v = $v.toString();
      while($v.length < 2) {
        $v = "0" + $v;
      }
      return $v;
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
